import React from "react";
import Toggle from "react-toggle";
import { getToggleProps } from "utils/form";
import SectionBezel from "components/SectionBezel";
import get from "lodash/get";
import { useFormikContext } from "formik";
import { EMBED_KEYS } from "utils/constants/embed";
import ZoneLink from "components/ZoneLink";
import { DOCS_ZONE_LINK } from "constants/docs";

const ParameterFields = () => {
  const { values, setFieldValue } = useFormikContext();

  return (
    <SectionBezel header="Parameters" expandable>
      <div className="f6 lh-copy">
        Control how additional parameters are passed from your host page to your
        embed.
      </div>
      <div className="pt3">
        <div className="flex flex-column w-100">
          <div className="flex flex-row items-center justify-between">
            <label className="f5 fw6 db">Forward query params</label>
            <Toggle
              {...getToggleProps({
                active: Boolean(get(values, EMBED_KEYS.PARAMS_EXTEND_QS)),
                setFieldValue: (_, active) => {
                  setFieldValue(EMBED_KEYS.PARAMS_EXTEND_QS, active);
                }
              })}
            />
          </div>
          <div className="f6 pt2 lh-copy">
            Enable to forward url query string parameters from the host page to
            your embed. This is helpful for tracking and prefill purposes.
          </div>
          {/* Fix link */}
          <div className="pt2">
            <ZoneLink
              href={DOCS_ZONE_LINK.LEARN_PAYMENT_LINKS_OVERVIEW}
              zone
              linkProps={{
                className: "link",
                target: "_blank"
              }}
            >
              <div className="f6 fw6 link__decoration--hover color-primary pointer">
                Learn more
              </div>
            </ZoneLink>
          </div>
        </div>
        <div className="flex flex-column w-100 pt3 mt3 bt hairline-1">
          <div className="flex flex-row items-center justify-between">
            <label className="f5 fw6 db">Return on cancel</label>
            <Toggle
              {...getToggleProps({
                active: Boolean(
                  get(values, EMBED_KEYS.PARAMS_INCLUDE_CANCEL_URL)
                ),
                setFieldValue: (_, active) => {
                  setFieldValue(EMBED_KEYS.PARAMS_INCLUDE_CANCEL_URL, active);
                }
              })}
            />
          </div>
          <div className="f6 pt2 lh-copy">
            Enable to return your customer to the host site if they cancel
            checkout. When not enabled, if your customer cancels a checkout
            session, they will be redirected to your standalone PriceBlocs
            hosted checkout page.
          </div>
          <div className="pt2">
            <ZoneLink
              href={DOCS_ZONE_LINK.LEARN_PAYMENT_LINKS_OVERVIEW}
              zone
              linkProps={{
                className: "link",
                target: "_blank"
              }}
            >
              <div className="f6 fw6 link__decoration--hover color-primary pointer">
                Learn more
              </div>
            </ZoneLink>
          </div>
        </div>
      </div>
    </SectionBezel>
  );
};

export default ParameterFields;
